import React from "react";
import { Button, Icon, Row, Col } from "antd";
import DoctorInfoTopView from "./DoctorInfoTopView";
import DoctorScheduleTabView from "./DoctorScheduleTabView";

import DoctorInfoContainer from "./DoctorInfoContainer";

export default class DoctorDetailView extends React.Component {
  render() {
    const {
      doctorsDetail,
      handleChange,
      showEditFeeInput,
      toggleAddFeeView,
      updateDoctorFees,
      togglePatientPerHourInput,
      fees,
      showEditPatientCountInput,
      patientsPerHour,
      updatePatientsPerHour,
      goToDoctorList,
      updateProcessing,
      getDetail,
      updateDoctorInfo,
      displayPhotos,
      getImageData,
      updateDoctorCertificate,
      regPhotoUrl,
      updateDoctorCertificateState,
      clinicId
    } = this.props;

    return (
      <div className="content-container">
        {/* <div className="back-btn-wrap">
          <Button type="primary" size="small" onClick={goToDoctorList}>
            <Icon type="left" />
            {strings.careplan.back}
          </Button>
        </div> */}
        {/* <Row type="flex">
          <Col span={24}>
            <DoctorInfoTopView
              doctorsDetail={doctorsDetail}
              handleChange={handleChange}
              showEditFeeInput={showEditFeeInput}
              toggleAddFeeView={toggleAddFeeView}
              updateDoctorFees={updateDoctorFees}
              togglePatientPerHourInput={togglePatientPerHourInput}
              fees={fees}
              showEditPatientCountInput={showEditPatientCountInput}
              patientsPerHour={patientsPerHour}
              updatePatientsPerHour={updatePatientsPerHour}
              updateProcessing={updateProcessing}
              displayPhotos={displayPhotos}
              getImageData={getImageData}
            />
          </Col>
        </Row> */}
        <Row type="flex" justify="space-between">
          <Col span={24}>
            <DoctorScheduleTabView
              doctorsDetail={doctorsDetail}
              getDetail={getDetail}
              clinicId={clinicId}
            />
            <DoctorInfoContainer
              doctorsDetail={doctorsDetail}
              getDetail={getDetail}
              updateDoctorInfo={updateDoctorInfo}
              updateProcessing={updateProcessing}
              displayPhotos={displayPhotos}
              getImageData={getImageData}
              updateDoctorCertificate={updateDoctorCertificate}
              regPhotoUrl={regPhotoUrl}
              updateDoctorCertificateState={updateDoctorCertificateState}
              clinicId={clinicId}
            />
          </Col>
        </Row>
      </div>
    );
  }
}
